import { defineComponent as _defineComponent } from 'vue'
import {computed, Ref, ref} from 'vue';
import LicensedModule from '@/assets/js/models/LicensedModule';
import PersistentDialog from "@aprocon-software/aprocon-main-components";
import {useStore} from "@/store";
import Services from "@/assets/js/services/Services";

export interface Props {
    value: LicensedModule,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationCard',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
    value: LicensedModule,
}


const messageDialog = ref();
const store = useStore();
const badges:Ref<any[]>=ref([]);
let badgesTimer!: any;
async function created(): Promise<void> {
    await loadBadges();
}

async function loadBadges(): Promise<void> {
    badges.value = await Services.Apps.getBadges(store.getters.branchId(),props.value.APPID);
    if (badgesTimer) {
        window.clearTimeout(badgesTimer);
    }
    badgesTimer = window.setTimeout(loadBadges, 20 * 1000);

}

// computedProps
const appName = computed<string>(() => {
    if (props.value) {
        return props.value.MANIFEST.TITLE;
    }
    return '?? APP';
});

const appIcon = computed<string>(() => {
    if (props.value) {
        return `data:image/svg+xml;base64,${btoa(props.value.MANIFEST.ICON_SVG)}`;
    }
    return './img/icons/icon-48.png';
});

const appDescription = computed<string>(() => {
    if (props.value) {
        return `<p><b>${props.value.MANIFEST.HEADER}</b></p><p><i>${props.value.MANIFEST.DETAILS}</i></p>`;
    }
    return '';
});

const appLink = computed<string>(() => {
    if (props.value.BASEURL) {
        let url = props.value.BASEURL;
        if (props.value.MANIFEST.SELFHOST) {
            if (url.endsWith('/')) {
                url += 'Account/LauncherLogin';
            } else {
                url += '/Account/LauncherLogin';
            }
        }
        // set userId, sid, service, isa in btoa string, auth=btoa(JSON.stringify({userId, sid, service, isa}));
        const authParam = btoa(JSON.stringify({
            userId: store.getters.userId(),
            sid: store.getters.authToken(),
            service: store.getters.serviceUrl(),
            branchId: store.getters.branchId(),
        }));
        return `${url}?caller=${window.location}&auth=${authParam}`;
    }
    return '#';
});

const dateDiff = computed<number>(() => {
    const diff = expiryDate.value.valueOf() - new Date().valueOf();
    return Math.ceil(diff / (1000 * 3600 * 24));
});

const expiryDate = computed<Date>(() => {
    let date = new Date();
    if (props.value) {
        if (props.value.LICENCEEXPIRYDATE) {
            const dmy = props.value.LICENCEEXPIRYDATE.split('.');
            date = new Date(`${dmy[2]}-${dmy[1]}-${dmy[0]}`);
        }
    }
    return date;
});

function showExclamationInfo(e: any): void {
    e.preventDefault();
    messageDialog.value.showError('Lizenz', `Die Lizenz läuft am '${props.value.LICENCEEXPIRYDATE}' ab.`);
}
function badgeClick(e: any, badgeText:string,color:string='#CCCCC', appTitle:string =''):void {
    console.log("badgeClick");
    e.preventDefault();
    console.log(color);

     messageDialog.value.show("fas fa-info-circle", appTitle, badgeText, color);
}


created();

return { __sfc: true,props, messageDialog, store, badges, badgesTimer, created, loadBadges, appName, appIcon, appDescription, appLink, dateDiff, expiryDate, showExclamationInfo, badgeClick, PersistentDialog }
}

})